var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridParchment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "614px",
    height: "612px",
    viewBox: "0 0 614 612",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/gridParchment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridParchment",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1.930818, 1.930818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8143361,541.01444 C9.81865597,487.222444 9.94890294,429.783533 9.03717419,375.600796 C9.03717419,345.253254 -5.15974486,323.446191 25.8390325,305.862851 C18.4149556,300.262231 9.68840901,300.262231 8.6464333,291.535685 C7.47421063,269.393701 15.0285345,260.146166 15.9402633,237.483195 C17.8939677,181.086259 22.1921175,204.14615 23.6248341,192.566599 C27.2717491,186.314745 33.9143443,181.495607 40.2964455,177.457951 C18.5452025,165.214736 17.5032268,171.336344 13.7260649,157.009178 C10.9908786,113.115951 1.87359118,60.3659307 22.1921175,19.598631 C205.189102,0.582574279 412.970222,19.2078901 596.357947,5.79245283 C597.139429,9.96035567 599.744368,12.6955419 599.483874,14.1282585 C602.479555,59.193708 602.077008,104.649898 598.039352,149.975842 C595.304166,171.206097 609.761579,198.9487 587.228854,210.149939 C580.977,214.578336 594.243584,219.788214 595.155312,225.519081 C598.541733,266.416627 596.197288,234.729402 598.020745,276.668924 C602.449142,320.431904 596.190487,306.439659 596.841722,350.593379 C606.089256,406.208833 587.854681,472.374291 602.442341,526.947768 C605.959009,538.669995 608.694195,581.911987 610.126912,596.760141 C585.249742,592.201497 541.226268,598.453351 531.587993,596.499647 C502.282426,594.285449 469.720685,599.886068 442.889811,587.252113 C440.154624,590.508287 436.637956,597.67187 434.554005,601.188538 C330.877422,614.473728 231.629235,607.310145 129.255122,594.415696 C122.873021,585.037914 123.654502,585.168161 120.398328,578.395319 C111.671782,584.256432 108.415608,590.37804 98.3865913,595.718165 C79.2402877,598.192858 58.9217613,595.06693 39.6452107,593.243473 C-8.15542503,592.07125 12.4235953,582.172481 12.8143361,541.01444 Z",
    id: "SHADOW",
    stroke: "#000000",
    strokeWidth: 2.89622642,
    fill: "#000000",
    opacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02188331,535.221988 C4.02620314,481.429992 4.15645011,423.991081 3.24472136,369.808344 C3.24472136,339.460801 -10.9521977,317.653738 20.0465797,300.070398 C12.6225028,294.469778 3.89595618,294.469778 2.85398047,285.743232 C1.6817578,263.601248 9.2360817,254.353714 10.1478104,231.690742 C12.1015149,175.293807 16.3996647,198.353697 17.8323813,186.774146 C21.4792963,180.522292 28.1218914,175.703154 34.5039927,171.665498 C12.7527497,159.422284 11.710774,165.543891 7.93361206,151.216725 C5.19842582,107.323498 -3.91886165,54.5734778 16.3996647,13.8061782 C199.396649,-5.20987855 407.177769,13.4154373 590.565494,6.13447997e-14 C591.346976,4.16790284 593.951916,6.90308908 593.691422,8.33580568 C596.687102,53.4012552 596.284555,98.8574455 592.246899,144.183389 C589.511713,165.413644 603.969126,193.156247 581.436401,204.357486 C575.184547,208.785883 588.451131,213.995761 589.362859,219.726628 C592.74928,260.624175 590.404835,228.936949 592.228293,270.876471 C596.656689,314.639451 590.398034,300.647206 591.049269,344.800927 C600.296803,400.41638 582.062228,466.581838 596.649888,521.155316 C600.166556,532.877542 602.901743,576.119534 604.334459,590.967688 C579.457289,586.409044 535.433815,592.660899 525.79554,590.707194 C496.489973,588.492996 463.928232,594.093615 437.097358,581.45966 C434.362171,584.715834 430.845503,591.879417 428.761552,595.396085 C325.084969,608.681275 225.836782,601.517692 123.462669,588.623243 C117.080568,579.245461 117.862049,579.375708 114.605875,572.602866 C105.879329,578.46398 102.623155,584.585587 92.5941385,589.925712 C73.4478348,592.400405 53.1293085,589.274478 33.8527579,587.45102 C-13.9478779,586.278797 6.63114242,576.380028 7.02188331,535.221988 Z",
    id: "STROKE_20701b46-787a-441e-aa2f-22b452f2d6a2_1_",
    stroke: "#3B465E",
    strokeWidth: 2.89622642,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "gridParchment",
    transform: "translate(8.619497, 16.411950)",
    stroke: "#5F7096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3.861635, 433.606918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0.00119637005 C12,-0.0987634285 12,6.09874408 8,5.99878428 C4,6.09874408 4,0.00119637005 8,0.00119637005 Z",
    id: "STROKE_8b6aa0db-a790-41e2-8bb8-d05243d4a29a",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73107456,43.0425667 C4.39733788,42.392829 4.79709587,42.1329339 5.06360119,42.1329339 C6.39612782,41.3532486 11.9927397,39.6639306 13.9915296,38.8842453",
    id: "STROKE_d60def88-6cd3-40f2-9a4d-106cbe74f102",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26287516,86.1851518 C9.99394972,82.9364632 13.1920136,83.3263058 17.7226042,81.2471451",
    id: "STROKE_8833ac8f-bfb3-4b65-986e-e1b4482a90b8",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,102.428595 C4.53059054,101.778857 7.06239114,100.869224 12.259245,99.3098539",
    id: "STROKE_338db44b-36d8-4574-9706-78efe77ccc9e",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.799515978,114.643664 C1.86553728,114.253822 2.39854793,113.863979 2.5318006,113.734031 C6.92913847,111.135081 6.1296225,112.044713 12.1259923,110.0955",
    id: "STROKE_a5860454-e64c-41d9-8756-da9599467109",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(6.965409, 0.688679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4248428,2.89622642 C23.4248428,3.02079529 23.5213836,3.26993305 23.6179245,3.51907081 C23.7144654,9.12467032 23.8110063,12.7371678 23.8110063,14.4811321",
    id: "STROKE_c912ef51-8462-46e3-9bcf-34b4bf463542",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4779874,0 C40.7758719,3.0735464 38.7865447,9.2206392 37.6163522,12.5503145",
    id: "STROKE_1b5ed413-2f6f-4c3c-899c-fea5764edcb2",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,21.0012157 C7,20.9012559 7,27.0987634 3,26.9988036 C-1,26.9988036 -1,20.9012559 3,21.0012157 Z",
    id: "STROKE_ec7665ca-08a1-4f62-8602-5db375489199",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(8.654088, 185.358491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75786164,1.93081761 C7.53265358,1.44811321 16.0263007,0.482704403 18.3081761,0",
    id: "STROKE_a0bdaa0b-72f0-473b-9f4d-b254e551bf69",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.75786164,
    y1: 12.0193396,
    x2: 11.5503145,
    y2: 12.1158805,
    id: "STROKE_4c2f79e5-7b3f-4ccd-a6aa-264ff9d5e6a6",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,35.0011964 C7,34.9012366 7,41.0987441 3,40.9987843 C-1,41.0987441 -1,35.0011964 3,35.0011964 Z",
    id: "STROKE_6bab7dc9-8888-43d2-bac0-79581cdc5be2",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(64.889937, 540.767296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.124479,11.6154242 C426.735524,11.8707083 425.827961,26.038973 425.69831,26.8048251",
    id: "STROKE_0f9379fc-86bf-4600-b913-0e32842e4e1a",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.441395,15.1894009 C439.311743,18.3804515 439.05244,23.2308485 438.533833,26.038973",
    id: "STROKE_3db7a005-6e02-4ec0-a7e2-e65707a4aa33",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,15.0011964 C385,14.9012366 385,21.0987441 381,20.9987843 C377,21.0987441 377,15.0011964 381,15.0011964 Z",
    id: "STROKE_3aeaa147-3552-4309-a633-d02ee2918270",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,17.0011964 C7,16.9012363 7,23.0987637 3,22.9988036 C-1,23.0987637 -1,16.9012363 3,17.0011964 Z",
    id: "STROKE_b68aacf4-331b-4eb3-9fba-01335c32d018",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8883348,3.70161871 C19.6290313,2.55284049 20.1476383,1.65934632 20.9255488,0",
    id: "STROKE_0849fa46-e492-4275-a52f-963501b953cc",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,8.00119637 C51,7.90123657 51,14.0987441 47,13.9987843 C43,14.0987441 43,8.00119637 47,8.00119637 Z",
    id: "STROKE_99753bfa-4460-4750-a2d2-d1ec9b0876a9",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,11.0011964 C413,10.9012366 413,17.0987441 409,16.9987843 C405,17.0987441 405,11.0011964 409,11.0011964 Z",
    id: "STROKE_1bf13978-ea39-43ff-b43e-bb2d1db9147b",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(559.559748, 106.194969)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.73518624
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26121336e-13,51.1666667 C2.51763473,48.1998006 9.80552473,46.9282865 13.5157233,45.3742138",
    id: "STROKE_131709a5-7398-4894-9dd5-d46fa574a232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79245283,22.2044025 C8.09761263,21.0459119 15.5253498,19.3725367 18.3427673,18.3427673",
    id: "STROKE_2d995f5e-8f0a-4d48-a348-a7a26cfe2a15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65408805,2.89622642 C10.9705546,1.20676101 12.0237278,1.44811321 15.4465409,1.0658141e-14",
    id: "STROKE_b969443d-69b8-474b-87f3-e4c2ab2f9cf6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(565.283019, 421.817610)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.73518624
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.34444535,1.22317429 C1.56296357,0.44169251 1.04197571,0.571939474 0,0.571939474",
    id: "STROKE_425311f7-079d-4ec3-bbca-690844c34b81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07963159,31.179976 C6.90308908,29.7472594 8.59629961,28.3145428 10.1592632,26.6213322",
    id: "STROKE_bbe56b82-8d3d-4449-b215-06c0ed1c7a58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(576.455975, 18.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.73518624
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.20440252,1.3081761 C0.941109205,1.04488279 0.590051458,0.693825043 0.238993711,0.342767296",
    id: "STROKE_661e2c0c-da9a-4d3e-8c6b-19300d012070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(4.861635, 303.138365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,39.0011964 C7,38.9012366 7,45.0987441 3,44.9987843 C-1,45.0987441 -1,39.0011964 3,39.0011964 Z",
    id: "STROKE_a0c99f13-cede-4e52-8ed5-9e4a9b1618fa",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36635718,25.134922 C7.57066664,25.2644834 6.90759119,25.7827292 6.24451573,26.8192209",
    id: "STROKE_77e80929-7789-45c5-b959-8fa96e1387c5",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0903534,2.20254471 C8.101127,0 8.49897227,0.647807267 5.84667046,0",
    id: "STROKE_2813956d-5be9-4906-9d22-66a214a841a3",
    strokeWidth: 2.73518624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3,306.001196 C7,305.901237 7,312.098744 3,311.998784 C-1,312.098744 -1,306.001196 3,306.001196 Z",
    id: "STROKE_b8de074c-66be-4281-a651-f0b89333762e",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M580.833333,418.161574 C584.833333,418.061614 584.833333,424.259141 580.833333,424.159181 C576.833333,424.259141 576.833333,418.061614 580.833333,418.161574 Z",
    id: "STROKE_557c8738-c95b-4aaa-983b-24df8f1a7d0f",
    stroke: "#5F7096",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.006289,22.3439637 C591.006289,22.2440039 591.006289,28.4415114 587.006289,28.3415516 C583.006289,28.4415114 583.006289,22.3439637 587.006289,22.3439637 Z",
    id: "STROKE_63147e3c-33c1-4e33-958d-077b54161d10",
    stroke: "#5F7096",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.967328,36.3439637 C585.019276,36.2440035 585.019276,42.441531 580.967328,42.3415709 C577.019276,42.441531 577.019276,36.2440035 580.967328,36.3439637 Z",
    id: "STROKE_8921ec8d-ba21-49d8-86f2-6f87370058bf",
    stroke: "#5F7096",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.006289,56.3439637 C592.006289,56.2440035 592.006289,62.441531 588.006289,62.3415709 C584.006289,62.441531 584.006289,56.2440035 588.006289,56.3439637 Z",
    id: "STROKE_e69f2c5e-d256-4a28-a071-277d1c54fb43",
    stroke: "#5F7096",
    strokeWidth: 0.5,
    fill: "#5F7096",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridParchment);
export default __webpack_public_path__ + "static/media/gridParchment.ef185489a8e478019315a8168fb26648.svg";
export { ForwardRef as ReactComponent };